import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import themeReducer from '@/features/theme/themeSlice';
import playerReducer from '@/features/player/playerSlice';
import contentReducer from '@/features/content/contentSlice';
import uiReducer from '@/features/ui/uiSlice';
import searchReducer from '@/features/search/searchSlice';
import authReducer from '@/features/auth/authSlice';
import sectionsReducer from '@/features/sections/sectionsSlice';
import tagsReducer from '@/features/tags/tagsSlice';

// Persist only activeAsset from the search slice
const searchPersistConfig = {
  key: 'search',
  storage,
  whitelist: ['activeAsset'],
};

// Persist token and name from auth — survives page refresh, cleared on logout
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token', 'name'],
};

const rootReducer = combineReducers({
  theme: themeReducer,
  player: playerReducer,
  content: contentReducer,
  ui: uiReducer,
  search: persistReducer(searchPersistConfig, searchReducer),
  auth: persistReducer(authPersistConfig, authReducer),
  sections: sectionsReducer,
  tags: tagsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // redux-persist dispatches non-serializable actions internally — ignore them
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
